module.exports = __webpack_public_path__ + "static/media/turokafteri_thumb2.dd5cc03a.jpg";